import { Group } from '@mantine/core';
import type { CompassCopy, CompassLocale } from '../i18n';
import { ThemeSwitch } from './ThemeSwitch';
import { LocaleSwitch } from './LocaleSwitch';

export function PreferenceControls(props: {
  locale: CompassLocale;
  copy: CompassCopy;
  onLocaleChange: (locale: CompassLocale) => void;
}): React.JSX.Element {
  const { locale, copy, onLocaleChange } = props;

  return (
    <Group gap="md">
      <ThemeSwitch copy={copy} />
      <LocaleSwitch locale={locale} copy={copy} onChange={onLocaleChange} />
    </Group>
  );
}
